export default "__VITE_ASSET__7bc2ae03__"